module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.d4b8110.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/Roboto-Bold.woff
// module id = LuMA
// module chunks = 0